import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Loader } from "components/Loader";
import { getColorWorkingHours } from "services/utils/Status";
import { DriveFileRenameOutline } from "@mui/icons-material";
import {
  tableData,
  attendanceStatusBox,
  attendanceStatusHalfBox,
} from "services/constants/Styles";
import { attendanceHeaderList } from "pages/TeamZone/TeamZoneHeaders";
import { useSelector } from "react-redux";
import {
  tableRowSx,
  themes,
  scrollTop,
  optionalAvathar,
  adminRoleName,
} from "services/constants";
import { EditCheckInOut } from "./EditCheckInOut";
import { showToast } from "services/utils/Status";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { InfoMessage } from "components/CustomComponents/CustomButton";

export const ListView = ({
  setEditCheckinDetailsId,
  setEditCheckInCheckOutDetails,
  departmentMembers,
  loading,
  filterDepartMemberList,
  masterDataForSearch,
  expand,
  setExpand,
  page,
  setPage,
  setGetUser,
  setUserId,
  shiftDetails,
  setShiftDetails,
  fetchStatus,
  openSidePeek,
  setOpenSidePeek,
}) => {
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [showDetails, setShowDetails] = useState(0);
  const [editState, setEditState] = useState(false);
  const containerRef = useRef(null);
  const { departmentId } = useSelector((state) => state.userReducer);
  const { userDetails: currentUserDetails, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  let access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Attendance",
    "Status"
  );
  const sortedData = filterDepartMemberList?.sort((a, b) =>
    a.user_name.localeCompare(b.user_name)
  );

  const handleCheckInCheckOutTime = (checkinDetails) => {
    setEditCheckinDetailsId(checkinDetails.id);
    setEditCheckInCheckOutDetails(checkinDetails);
  };

  useEffect(() => {
    const recallApi = () => {
      setEditState(false);
      fetchStatus(true);
    };
    if (editState && !openSidePeek) {
      recallApi();
    }
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (expand) {
      setShowDetails(0);
      setExpand(false);
    }
  }, [expand, setExpand]);

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  return loading ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      {departmentMembers?.length !== 0 ? (
        <Mui.Stack sx={{ paddingTop: 2 }}>
          <>
            <Mui.TableContainer
              ref={containerRef}
              sx={{
                paddingLeft: 3,
                width: "100%",
                paddingRight: 3,
                maxHeight: 550,
              }}
            >
              <Mui.Table>
                <Mui.TableHead
                  sx={{
                    backgroundColor: themes.primary,
                    position: "sticky",
                    top: -1,
                    zIndex: 10,
                  }}
                >
                  <Mui.TableRow sx={tableRowSx}>
                    {attendanceHeaderList.map((header) => (
                      <Mui.TableCell sx={tableData}>
                        {header.name}
                      </Mui.TableCell>
                    ))}
                    {currentUserDetails.type === "Team Lead" ||
                    currentUserDetails.type === adminRoleName ? (
                      <Mui.TableCell sx={tableData}>Action</Mui.TableCell>
                    ) : null}
                    <Mui.TableCell></Mui.TableCell>
                  </Mui.TableRow>
                </Mui.TableHead>
                <Mui.TableBody>
                  {sortedData.length === 0 ? (
                    <InfoMessage dataLength={masterDataForSearch} />
                  ) : (
                    sortedData
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((item) => (
                        <>
                          <Mui.TableRow sx={tableRowSx}>
                            <Mui.TableCell sx={tableData}>
                              {item?.id === showDetails ? (
                                <Mui.IconButton
                                  onClick={() => {
                                    setShowDetails(0);
                                    setEditCheckinDetailsId(0);
                                  }}
                                >
                                  <KeyboardArrowDownIcon />
                                </Mui.IconButton>
                              ) : (
                                <Mui.IconButton
                                  onClick={() => {
                                    setShowDetails(item?.id);
                                    setEditCheckinDetailsId(0);
                                  }}
                                  style={{
                                    padding: "0px",
                                  }}
                                >
                                  <ChevronRightIcon />
                                </Mui.IconButton>
                              )}
                            </Mui.TableCell>
                            <Mui.TableCell>
                              <Mui.Stack direction="Row">
                                <Mui.Avatar
                                  sx={{ width: 23, height: 23 }}
                                  alt={item?.user_name?.charAt(0).toUpperCase()}
                                  src={item?.image_url ?? optionalAvathar}
                                />
                                <Mui.Typography
                                  sx={{
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    paddingLeft: 1,
                                  }}
                                >
                                  {item?.user_name ? item?.user_name : "N/A"}
                                </Mui.Typography>
                              </Mui.Stack>
                            </Mui.TableCell>
                            <Mui.TableCell>
                              {item?.shift_name ? item?.shift_name : "N/A"}
                            </Mui.TableCell>
                            <Mui.TableCell>
                              {item?.check_in_time_formatted}
                            </Mui.TableCell>
                            <Mui.TableCell>
                              {item?.check_out_time_formatted}
                            </Mui.TableCell>
                            <Mui.TableCell>
                              {item?.total_break_time ||
                              item?.total_break_time === ""
                                ? item?.total_break_time
                                : item?.status === "A" || item?.status === "W"
                                ? ""
                                : "N/A"}
                            </Mui.TableCell>
                            <Mui.TableCell>
                              {item?.shift_hours || item?.shift_hours === ""
                                ? item?.shift_hours
                                : item?.status === "A" || item?.status === "W"
                                ? ""
                                : "N/A"}
                            </Mui.TableCell>

                            <Mui.TableCell>
                              {item?.total_over_time
                                ? item?.total_over_time
                                : item?.status === "A" || item?.status === "W"
                                ? ""
                                : "N/A"}
                            </Mui.TableCell>
                            <Mui.TableCell>
                              {item?.shift_default_unit}
                            </Mui.TableCell>
                            <Mui.TableCell>
                              {item?.total_work_time
                                ? item?.total_work_time
                                : item?.status === "A" || item?.status === "W"
                                ? ""
                                : "N/A"}
                            </Mui.TableCell>
                            <Mui.TableCell>
                              {item?.Leave_credit_hours
                                ? item?.Leave_credit_hours
                                : item?.status === "A" ||
                                  item?.status === "W" ||
                                  item?.status === "P" ||
                                  item?.status === "PR"
                                ? ""
                                : ""}
                            </Mui.TableCell>

                            <Mui.TableCell>
                              <Mui.Typography
                                sx={{
                                  display: "inline-block",
                                  color:
                                    item.status === "W"
                                      ? themes?.headLine
                                      : themes.whiteColor,
                                  border:
                                    item.status === "W"
                                      ? "1px solid black"
                                      : "none",
                                  ...attendanceStatusBox,
                                  backgroundColor: getColorWorkingHours(
                                    item.status
                                  ),
                                }}
                              >
                                {item.status === "PL" ||
                                item.status === "LP" ||
                                item.status === "AL" ||
                                item.status === "LA" ||
                                item.status === "HL" ? (
                                  <Mui.Grid container>
                                    {item.status === "PL" && (
                                      <>
                                        <Mui.Typography
                                          sx={{
                                            ...attendanceStatusHalfBox,
                                            backgroundColor: themes.greenColor,
                                          }}
                                        >
                                          P
                                        </Mui.Typography>
                                        <Mui.Typography
                                          sx={{
                                            ...attendanceStatusHalfBox,
                                            backgroundColor: themes.yellowColor,
                                          }}
                                        >
                                          L
                                        </Mui.Typography>
                                      </>
                                    )}
                                    {item.status === "LP" && (
                                      <>
                                        <Mui.Typography
                                          sx={{
                                            ...attendanceStatusHalfBox,
                                            backgroundColor: themes.yellowColor,
                                          }}
                                        >
                                          L
                                        </Mui.Typography>
                                        <Mui.Typography
                                          sx={{
                                            ...attendanceStatusHalfBox,
                                            backgroundColor: themes.greenColor,
                                          }}
                                        >
                                          P
                                        </Mui.Typography>
                                      </>
                                    )}
                                    {item.status === "AL" && (
                                      <>
                                        <Mui.Typography
                                          sx={{
                                            ...attendanceStatusHalfBox,
                                            backgroundColor: themes.redColor,
                                          }}
                                        >
                                          A
                                        </Mui.Typography>
                                        <Mui.Typography
                                          sx={{
                                            ...attendanceStatusHalfBox,
                                            backgroundColor: themes.yellowColor,
                                          }}
                                        >
                                          L
                                        </Mui.Typography>
                                      </>
                                    )}
                                    {item.status === "LA" && (
                                      <>
                                        <Mui.Typography
                                          sx={{
                                            ...attendanceStatusHalfBox,
                                            backgroundColor: themes.yellowColor,
                                          }}
                                        >
                                          L
                                        </Mui.Typography>
                                        <Mui.Typography
                                          sx={{
                                            ...attendanceStatusHalfBox,
                                            backgroundColor: themes.redColor,
                                          }}
                                        >
                                          A
                                        </Mui.Typography>
                                      </>
                                    )}

                                    {item.status === "HL" && (
                                      <>
                                        <Mui.Typography
                                          sx={{
                                            ...attendanceStatusHalfBox,
                                            backgroundColor:
                                              item.half_day_leave_period ===
                                              "2nd"
                                                ? themes.greenColor
                                                : themes.yellowColor,
                                          }}
                                        >
                                          H
                                        </Mui.Typography>
                                        <Mui.Typography
                                          sx={{
                                            ...attendanceStatusHalfBox,
                                            backgroundColor:
                                              item.half_day_leave_period ===
                                              "2nd"
                                                ? themes.yellowColor
                                                : themes.greenColor,
                                          }}
                                        >
                                          L
                                        </Mui.Typography>
                                      </>
                                    )}
                                  </Mui.Grid>
                                ) : (
                                  item.status
                                )}
                              </Mui.Typography>
                            </Mui.TableCell>
                            <Mui.TableCell>
                              <>
                                <Mui.Grid container xs={12}>
                                  <Mui.Grid item xs={5}>
                                    <Mui.IconButton
                                      onClick={() => {
                                        if (access) {
                                          if (
                                            (item.shift_name !== "Unassigned" &&
                                              item?.user_id !==
                                                currentUserDetails?.id) ||
                                            (currentUserDetails?.type ===
                                              adminRoleName &&
                                              item.shift_name !== "Unassigned")
                                          ) {
                                            handleCheckInCheckOutTime(item);
                                            setShiftDetails({
                                              ...item,
                                              shift_filter_date: item.date
                                                .split("-")
                                                .reverse()
                                                .join("-"),
                                            });
                                            setUserId(item?.user_id);
                                            setGetUser(true);
                                            setOpenSidePeek(true);
                                          } else {
                                            if (
                                              item?.user_id ===
                                              currentUserDetails?.id
                                            ) {
                                              showToast(
                                                "error",
                                                "Your data cannot be edited by yourself"
                                              );
                                            } else {
                                              showToast(
                                                "error",
                                                "Unassigned shifts cannot be edited"
                                              );
                                            }
                                          }
                                        } else {
                                          showToast(
                                            "error",
                                            "Access denied: You are not authorized to modify this data"
                                          );
                                        }
                                      }}
                                    >
                                      <DriveFileRenameOutline />
                                    </Mui.IconButton>
                                  </Mui.Grid>

                                  <Mui.Grid item xs={5}></Mui.Grid>
                                </Mui.Grid>
                              </>
                            </Mui.TableCell>
                            <Mui.TableCell></Mui.TableCell>
                          </Mui.TableRow>
                          {showDetails === item?.id && (
                            <Mui.TableRow sx={tableRowSx}>
                              <Mui.TableCell colSpan={13}>
                                <Mui.TableContainer
                                  sx={{
                                    marginTop: 0,
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    width: "100%px",
                                  }}
                                  className="w-96 border rounded"
                                >
                                  {item?.break_details?.length !== 0 ? (
                                    <Mui.Stack>
                                      <Mui.Table className="border">
                                        <Mui.TableHead
                                          sx={{
                                            backgroundColor: themes.primary,
                                          }}
                                        >
                                          <Mui.TableRow sx={tableRowSx}>
                                            <Mui.TableCell sx={tableData}>
                                              Break Start
                                            </Mui.TableCell>
                                            <Mui.TableCell sx={tableData}>
                                              Break End
                                            </Mui.TableCell>
                                            <Mui.TableCell sx={tableData}>
                                              Break-Time
                                            </Mui.TableCell>
                                          </Mui.TableRow>
                                        </Mui.TableHead>
                                        <Mui.TableBody>
                                          {item?.break_details?.map(
                                            (breaks, index) => (
                                              <Mui.TableRow
                                                key={index}
                                                sx={tableRowSx}
                                              >
                                                <Mui.TableCell>
                                                  {breaks?.break_out_formatted}
                                                </Mui.TableCell>

                                                <Mui.TableCell>
                                                  {breaks?.break_in_formatted}
                                                </Mui.TableCell>

                                                <Mui.TableCell>
                                                  {
                                                    breaks?.individual_break_time
                                                  }
                                                </Mui.TableCell>
                                              </Mui.TableRow>
                                            )
                                          )}
                                        </Mui.TableBody>
                                        <Mui.TableBody>
                                          <Mui.TableRow sx={tableRowSx}>
                                            <Mui.TableCell></Mui.TableCell>
                                            <Mui.TableCell>
                                              {" "}
                                              <Mui.Typography>
                                                Total
                                              </Mui.Typography>
                                            </Mui.TableCell>
                                            <Mui.TableCell>
                                              {item?.total_break_time
                                                ? item?.total_break_time
                                                : "N/A"}
                                            </Mui.TableCell>
                                          </Mui.TableRow>
                                        </Mui.TableBody>
                                      </Mui.Table>
                                    </Mui.Stack>
                                  ) : (
                                    <Mui.Stack
                                      sx={{ padding: 0.5 }}
                                      spacing={2}
                                      fullWidth
                                    >
                                      <Mui.Alert severity="info">
                                        There is a no available breaks
                                      </Mui.Alert>
                                    </Mui.Stack>
                                  )}
                                </Mui.TableContainer>
                              </Mui.TableCell>
                            </Mui.TableRow>
                          )}
                        </>
                      ))
                  )}
                </Mui.TableBody>
              </Mui.Table>
            </Mui.TableContainer>
            {sortedData?.length > 25 && (
              <Mui.TablePagination
                className="custom-pagination"
                component="div"
                rowsPerPageOptions={[25, 50, 75, 100]}
                count={sortedData?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </>
        </Mui.Stack>
      ) : (
        <Mui.Alert severity="info" sx={{ width: "100%", margin: 2 }}>
          No members are there in this group
        </Mui.Alert>
      )}

      {openSidePeek ? (
        <EditCheckInOut
          setOpenSidePeek={setOpenSidePeek}
          openSidePeek={openSidePeek}
          shiftDetails={shiftDetails}
          setEditState={setEditState}
          departmentId={departmentId}
        />
      ) : null}
    </React.Fragment>
  );
};
